<template>
    <toolbar-option>
        <template slot="primary">
            <toggle
                :value="checked"
                :messages="messages"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'row-shading';

export default {
    name: 'row-shading',
    mixins: [baseOption],

    data() {
        return {
            checked: false,
            displayName: 'Row Shading',

            messages: {
                checked: 'On',
                unchecked: 'Off',
            },
        };
    },

    methods: {
        onInput(isChecked) {
            if (isChecked) {
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, String(isChecked));
            } else {
                this.selectedElements[0].removeElementData(CUSTOM_ATTR_NAME);
            }

            this.checked = isChecked;
            this.onOptionChange(isChecked);
        },

        onSelectedElement() {
            this.checked = this.selectedElements[0].hasElementData(CUSTOM_ATTR_NAME);
        },
    },
};
</script>
